<!-- Displaying all the graphs generated by user -->
<!-- Loader-->
<ng-container *ngIf="loading">
    <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</ng-container>
<!-- End of Loader -->
<!-- no access in case role is not customer-->
<ng-container *ngIf="!loading">
  <ng-container *ngIf="role && role !== 'CUSTOMER'">
    <h1>UNAUTHORISED ACCESS</h1> <br>
    <h3>Please Login as CUSTOMER, redirecting ...</h3>
    {{unauthorised()}}
  </ng-container>
  <ng-container *ngIf="role && role === 'CUSTOMER'">
    <div class="wrapper ">
      <br>
      <div>
        <div class="content">
          <ng-container *ngIf="graphs">
            <div class="alert alert-danger" role="alert" *ngIf="graphs.length === 0">
              No graphs
            </div>
            <div class="alert alert-primary" role="alert" *ngIf="graphs.length !== 0">
              Your graphs
            </div>
            <div class="card">
            <div class="card-body">

              <div class="form-container">

                <form [formGroup]="filterForm" autocomplete="off">
                  <div class="filter-container">

                    <div>
                      <mat-form-field appearance="fill">
                      <mat-label id="head" >Created Between: </mat-label>
                      <mat-date-range-input [rangePicker]="picker" >
                      <input formControlName="startDate" matStartDate placeholder="Start date" required>
                      <input formControlName="endDate" matEndDate placeholder="End date" required>
                      </mat-date-range-input>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                    </div>





                <div>
                  <!-- <mat-radio-group formControlName="iron1" required>
                    <mat-radio-button value="Grey Iron"><h6 id="head">Grey Iron</h6></mat-radio-button>&nbsp;&nbsp;
                    <mat-radio-button value="Ductile Iron"><h6 id="head">Ductile Iron</h6></mat-radio-button>
                  </mat-radio-group> -->
                  <mat-form-field appearance="fill" style="margin: 0 auto;">
                    <mat-label >CLASS : </mat-label>
                    <mat-select formControlName="iron1" required>
                      <mat-option *ngFor="let type of gIron" [value]="type">
                        {{ type }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                    <div>
                      <!-- <mat-radio-group formControlName="iron2" required>
                    <mat-radio-button value="Base Iron"><h6 id="head">Base Iron</h6></mat-radio-button>&nbsp;&nbsp;
                    <mat-radio-button value="Final Iron"><h6 id="head">Final Iron</h6></mat-radio-button>
                  </mat-radio-group> -->
                  <mat-form-field appearance="fill" style="margin: 0 auto;">
                    <mat-label >IRON TYPE: </mat-label>
                    <mat-select formControlName="iron2" required>
                      <mat-option *ngFor="let type of ironType" [value]="type">
                        {{ type }}
                         </mat-option>
                         </mat-select>
                      </mat-form-field>
                    </div>


                      <div>
                        <mat-form-field appearance="fill" style="margin: 0 auto;">
                          <mat-label >GRADE: </mat-label>
                          <mat-select formControlName="grade" required>
                            <mat-option *ngFor="let type of drp_grade1" [value]="type">
                              {{ type }}
                               </mat-option>
                               </mat-select>
                            </mat-form-field>
                        <!--changed as grade dropdown from input box-->
                        <!--    <h5 class="card-title">GRADE :</h5>
                        <input id="nameright" type="text" class="card3" formControlName="grade1" > -->
                      </div>

                  </div>

                  <div class="button-container">
                    <button type="button" class="btn btn-success" (click)="filter()">FILTER</button>
                    <button type="button" class="btn btn-warn" (click)="reset()">RESET</button>
                </div>

                <mat-error *ngIf="missingFields" style="margin-top: 10px;">All fields are required. Grade is Optional.</mat-error>
                </form>

              </div>



              <br>
              <table class="table table-hover" style="text-align:center">
                <thead class="text-primary">
                  <tr style="text-align:center">
                    <!-- <th scope="col">CLASS</th> -->
                    <th scope="col">SR. NO</th>
                    <th scope="col">DATE</th>
                    <th scope="col">CLASS</th>
                    <th scope="col">GRADE</th>
                    <th scope="col">TYPE</th>
                    <th scope="col">HEAT ID</th>
                    <th scope="col">FURNACE</th>
                    <th scope="col">OPERATOR</th>
                    <th scope="col">PAYMENT STATUS</th>
                    <!-- <th scope="col">Temperature reading</th>
                    <th scope="col">tive reading</th>
                    <th scope="col">Thermal Values reading</th> -->
                    <th scope="col">ACTIONS</th>
                    <th scope="col">CURVE ID</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let graph of graphs let i = index">
                    <td>{{ i+1 }}</td>
                    <!--<td>{{ transformDate(graph.createdAt) }}</td>-->
                    <td>{{ (graph.createdAt) }}</td>
                    <td>{{ graph.iron1 }}</td>
                    <td>{{ graph.grade }}</td>
                    <td>{{ graph.iron2 }}</td>
                    <td>{{ graph.heatId }}</td>

                    <td>{{ graph.furnaceNumber }}</td>
                    <td>{{ graph.operator }}</td>
                    <td>
                      <div *ngIf="graph.paid" style="text-align: center;">Paid</div>
                      <div *ngIf="!graph.paid"style="text-align: center;">Not Paid</div>
                    </td>
                    <!-- <td>
                      <div *ngIf="graph.dataPoints['temperature'].length !== 0">
                        Temperature reading Present
                      </div>
                      <div *ngIf="graph.dataPoints['temperature'].length === 0">
                        Temperature reading Absent
                      </div>
                    </td> -->

                    <!-- <td>
                      <div *ngIf="graph.derivatives">
                        Derivatives present
                      </div>
                      <div *ngIf="!graph.derivatives">
                        Derivatives Absent
                      </div>
                    </td> -->

                    <!-- <td>
                      <div *ngIf="graph.thermalValues">
                        Thermal Values Present
                      </div>
                      <div *ngIf="!graph.thermalValues">
                        Thermal Values Absent
                      </div>
                    </td> -->

                    <td>
                      <div class="button-cont">
                        <button type="button" class="curve-btn" (click)="sendCurveDataToAnalyser(graph._id, graph.paid, graph.heatNumber)">VIEW CURVE</button>
                        <button class="support-btn" [disabled]="!graph.paid" (click)="open(mymodal, graph)">SUPPORT</button>
                      </div>
                    </td>
                    <td>{{ graph._id }}</td>
                  </tr>
                </tbody>
              </table>







              <ng-template #mymodal let-modal>
                <div class="modal-header">
                  <h4 class="modal-title" id="modal-basic-title" style="color:black;font-weight:800;font-family:Calibri;font-size:20px;" >"Please enter your Query to raise a ticket"</h4>
                  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <form (submit)="saveTicket()" [formGroup]="ticketForm">
                  <div class="modal-body" style="margin: 0 auto;">
                    <textarea rows="6" style="width:100%;" formControlName="ticket"></textarea>
                    <br><br>
                    <div class="columns">
                      <div class="column is-one-third">
                        <div class="field">
                          <div class="file has-name is-primary is-fullwidth">
                        <!--    <label class="file-label">
                              <input
                                class="file-input"
                                type="file"
                                name="file"
                                #fileInput
                                (change)="onChange(fileInput.files[0])"
                              />
                            </label>-->
                          </div>
                        </div>

                      </div>
                      <div class="column">
                        <figure *ngIf="imageUrl!=''">
                          <img height="300" width="300" [src]="imageUrl" />
                        </figure>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-outline-dark" (click)="modal.close('Save click')">raise ticket</button>
                  </div>

                </form>
              </ng-template>







            </div>
          </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<!-- end of graph display-->
